import { sceneryTile as tile, type WorldBackdrop } from './worldShapeKit';

/** Broad crowns, thin bamboo culms, and flat acacia canopies have deliberately
 * different negative space. The short near bank leaves actor silhouettes clear. */
export const WOODLAND_BACKDROPS = {
  forest: {
    far: tile('hills', [['fir', 280, 267, 240, 220], ['fir', 1230, 260, 205, 195], ['fir', 1920, 316, 220, 180]]),
    mid: tile('banks', [['oak', 140, 310, 310, 266], ['oak', 1130, 320, 380, 305], ['fir', 1960, 331, 200, 242]]),
    near: tile('banks', [['reeds', 240, 310, 110, 64], ['oak', 1630, 345, 225, 145]]),
  },
  autumn: {
    far: tile('hills', [['maple', 160, 285, 330, 244], ['maple', 1300, 275, 260, 222]]),
    mid: tile('banks', [['oak', 100, 307, 360, 282], ['maple', 1060, 322, 340, 310], ['maple', 1870, 332, 250, 225]]),
    near: tile('hills', [['maple', 510, 300, 160, 114], ['reeds', 1540, 316, 96, 63]]),
  },
  bamboo: {
    far: tile('hills', [['mountain', 180, 304, 620, 230], ['mountain', 1320, 310, 580, 212]]),
    mid: tile('banks', [['bamboo', 210, 305, 150, 290], ['bamboo', 400, 320, 125, 260], ['bamboo', 1430, 330, 190, 315], ['bamboo', 1700, 340, 122, 254]]),
    near: tile('banks', [['bamboo', 740, 331, 160, 257], ['reeds', 1870, 335, 150, 102]]),
  },
  sakura: {
    far: tile('hills', [['mountain', 720, 317, 860, 250]]),
    mid: tile('banks', [['blossom', 130, 315, 440, 288], ['blossom', 1240, 330, 490, 307]]),
    near: tile('hills', [['blossom', 610, 319, 290, 210], ['reeds', 1810, 335, 95, 50]]),
  },
  jungle: {
    far: tile('hills', [['mesa', 260, 307, 480, 243], ['mesa', 1310, 315, 380, 190]]),
    mid: tile('banks', [['oak', 130, 310, 410, 290], ['palm', 920, 330, 250, 318], ['oak', 1650, 340, 440, 315]]),
    near: tile('banks', [['palm', 430, 327, 290, 288], ['reeds', 1410, 316, 230, 138]]),
  },
  meadow: {
    far: tile('hills', [['oak', 450, 290, 180, 120], ['oak', 1410, 285, 145, 115]]),
    mid: tile('hills', [['oak', 1660, 321, 250, 216]]),
    near: tile('banks', [['reeds', 280, 310, 90, 72], ['reeds', 1330, 315, 120, 89]]),
  },
  village: {
    far: tile('hills', [['fir', 460, 287, 145, 143], ['fir', 1280, 260, 170, 167]]),
    mid: tile('banks', [['gable', 210, 305, 245, 203], ['gable', 1060, 323, 280, 245], ['oak', 1740, 335, 320, 266]]),
    near: tile('banks', [['gable', 640, 327, 240, 164], ['reeds', 1650, 333, 108, 68]]),
  },
  lanternwood: {
    far: tile('hills', [['fir', 340, 290, 240, 252], ['fir', 1170, 290, 170, 232]]),
    mid: tile('banks', [['willow', 80, 315, 370, 299], ['oak', 1070, 330, 340, 296], ['snag', 1750, 335, 175, 224]]),
    near: tile('banks', [['snag', 650, 330, 210, 218], ['reeds', 1500, 335, 155, 110]]),
  },
} satisfies Record<string, WorldBackdrop>;
